var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productQuotationApplicationAdd container" },
    [
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _c(
            "div",
            [
              _vm.saveBtnShow
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: (_vm.ProApplyCreateApply, _vm.ProApplyUpdate),
                          expression: "ProApplyCreateApply,ProApplyUpdate",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveQuotationApply(2)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.submitBtnShow
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.ProApplySubmitApply,
                          expression: "ProApplySubmitApply",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.submitQuotationApply },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.historyBack },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "applyInfoForm",
              staticClass: "topform",
              attrs: {
                "label-width": "120px",
                model: _vm.searchForm,
                "label-position": "right",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单据编号" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.searchForm.applyNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "applyNo", $$v)
                              },
                              expression: "searchForm.applyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: !_vm.saveBtnShow,
                              clearable: "",
                              placeholder: "请输入主题",
                              maxlength: "300",
                            },
                            model: {
                              value: _vm.searchForm.subject,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "subject", $$v)
                              },
                              expression: "searchForm.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              staticStyle: { width: "100%" },
                              attrs: { disabled: true },
                              model: {
                                value: _vm.searchForm.applyType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "applyType", $$v)
                                },
                                expression: "searchForm.applyType",
                              },
                            },
                            _vm._l(_vm.applyTypeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建人" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.searchForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "name", $$v)
                              },
                              expression: "searchForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建日期" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "选择日期",
                              disabled: "",
                            },
                            model: {
                              value: _vm.searchForm.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "createDate", $$v)
                              },
                              expression: "searchForm.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "产品报价明细", name: "first" } },
            [
              _c(
                "el-row",
                {
                  staticClass: "action-btn-row",
                  attrs: { type: "flex", justify: "start", align: "middle" },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.ProApplyCreateDetail,
                          expression: "ProApplyCreateDetail",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.applyLineEdit,
                          expression: "applyLineEdit",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.showApplyLineAddDialogFunc()
                        },
                      },
                    },
                    [_vm._v("新增")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.ProApplyDeleteDetail,
                          expression: "ProApplyDeleteDetail",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.applyLineEdit,
                          expression: "applyLineEdit",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.delSelQuotationApplyLine()
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                  _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.ProApplyDeleteDetail,
                          expression: "ProApplyDeleteDetail",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.applyLineEdit,
                          expression: "applyLineEdit",
                        },
                      ],
                      attrs: {
                        accept: ".xls,.xlsx",
                        "on-error": _vm.importDetailError,
                        "on-success": _vm.importDetailSuccess,
                        "before-upload": _vm.beforeUpload,
                        "show-file-list": false,
                        action: _vm.importDetailUrl,
                        multiple: "false",
                        headers: _vm.headers,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { type: "primary", size: "mini" },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.import")))]
                      ),
                    ],
                    1
                  ),
                  _vm.ttQuotationApplyId !== -1
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.ProApplyExport,
                              expression: "ProApplyExport",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onExport },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.export")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-link",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.ProApplyDeleteDetail,
                          expression: "ProApplyDeleteDetail",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.applyLineEdit,
                          expression: "applyLineEdit",
                        },
                      ],
                      attrs: {
                        type: "button",
                        target: "_blank",
                        href: "static/template/RFQ(Material)Template.xlsx",
                        download: "RFQ(Material)Template.xlsx",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { height: "100%" },
                          attrs: { type: "primary", size: "mini" },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.templateDownload")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "ux-grid",
                {
                  ref: "applyProductTableDataRef",
                  attrs: {
                    data: _vm.applyProductTableData,
                    "keep-source": "",
                    "max-height": "550",
                    "highlight-current-row": "",
                    "show-overflow": "tooltip",
                  },
                },
                [
                  _c("ux-table-column", {
                    attrs: { align: "center", type: "checkbox", width: "80" },
                  }),
                  _c("ux-table-column", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.disableEditor,
                        expression: "!disableEditor",
                      },
                    ],
                    attrs: {
                      align: "center",
                      title: "操作",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("i", {
                              staticClass: "el-icon-edit-outline",
                              on: {
                                click: function ($event) {
                                  return _vm.onEdit(scope)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "序号",
                      type: "index",
                      width: "60",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "8位码",
                      field: "eightBitCode",
                      "min-width": "140",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "8位码名称",
                      field: "eightBitCodeName",
                      "min-width": "200",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "提货点",
                      field: "pickupPoint",
                      "min-width": "100",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "到货仓库（DC）",
                      field: "dcName",
                      "min-width": "150",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "运输方式",
                      field: "transportaionMethod",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("ic")(
                                    scope.row.transportaionMethod,
                                    "COMMON",
                                    "TRANSPORTAION_METHOD"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "温区",
                      field: "temperatureI18n",
                      "min-width": "70",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "产品有效开始日期",
                      field: "effectiveBeginDate",
                      "min-width": "150",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      sortable: "",
                      resizable: "",
                      title: "入围供应商",
                      field: "supplierNames",
                      "min-width": "140",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "8位码选择",
            visible: _vm.dialogVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "materialSearchForm",
              attrs: {
                model: _vm.materialSearchForm,
                "label-width": "120px",
                inline: "",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "8位码编号:",
                    size: "small",
                    prop: "eightBitCode",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.eightBitCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "eightBitCode", $$v)
                      },
                      expression: "materialSearchForm.eightBitCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "8位码名称:",
                    size: "small",
                    prop: "eightBitCodeName",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.eightBitCodeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.materialSearchForm,
                          "eightBitCodeName",
                          $$v
                        )
                      },
                      expression: "materialSearchForm.eightBitCodeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "工厂编号:", size: "small", prop: "plantNo" },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.plantNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "plantNo", $$v)
                      },
                      expression: "materialSearchForm.plantNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "工厂名称:",
                    size: "small",
                    prop: "plantName",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.plantName,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "plantName", $$v)
                      },
                      expression: "materialSearchForm.plantName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "供应商编号:",
                    size: "small",
                    prop: "supplierCode",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.supplierCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "supplierCode", $$v)
                      },
                      expression: "materialSearchForm.supplierCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "供应商名称:",
                    size: "small",
                    prop: "supplierName",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.supplierName,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "supplierName", $$v)
                      },
                      expression: "materialSearchForm.supplierName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "提货点:",
                    size: "small",
                    prop: "pickupPoint",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.pickupPoint,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "pickupPoint", $$v)
                      },
                      expression: "materialSearchForm.pickupPoint",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "DC:", size: "small", prop: "dcName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.dcName,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "dcName", $$v)
                      },
                      expression: "materialSearchForm.dcName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "温区:", size: "small", prop: "temperature" },
                },
                [
                  _c("ic-select", {
                    staticClass: "handle-input",
                    attrs: {
                      table: "COMMON",
                      field: "TEMPERATURE",
                      clearable: "",
                    },
                    model: {
                      value: _vm.materialSearchForm.temperature,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "temperature", $$v)
                      },
                      expression: "materialSearchForm.temperature",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "运输方式:",
                    size: "small",
                    prop: "transportaionMethod",
                  },
                },
                [
                  _c("ic-select", {
                    staticClass: "handle-input",
                    attrs: {
                      table: "COMMON",
                      field: "TRANSPORTAION_METHOD",
                      clearable: "",
                    },
                    model: {
                      value: _vm.materialSearchForm.transportaionMethod,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.materialSearchForm,
                          "transportaionMethod",
                          $$v
                        )
                      },
                      expression: "materialSearchForm.transportaionMethod",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fatchMaterial(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.restQueryForm()
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createDetailMateria()
                    },
                  },
                },
                [_vm._v("选择")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.toggleSelection },
                },
                [_vm._v(_vm._s(_vm.$t("common.Deselected")))]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "materialListRef",
              staticClass: "dialogIntable",
              attrs: {
                data: _vm.materialList,
                border: "",
                "row-key": "tmMaterialId",
                "highlight-current-row": "",
                "max-height": "300",
              },
              on: { "selection-change": _vm.handleSelectionChangeMateria },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  "min-width": "55",
                  "reserve-selection": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "eightBitCode",
                  "min-width": "70",
                  label: "8位码",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "eightBitCodeName",
                  "min-width": "150",
                  label: "8位码名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "plantNo",
                  "min-width": "80",
                  label: "对应工厂编号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "plantName",
                  label: "对应工厂名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "supplierCode",
                  "min-width": "100",
                  label: "供应商编号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "supplierName",
                  "min-width": "200",
                  label: "供应商名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "dcName",
                  label: "DC",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "temperatureI18n",
                  "min-width": "60",
                  label: "温区",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "transportaionMethodI18n",
                  "min-width": "100",
                  label: "运输方式",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.materialSearchForm.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.materialSearchForm.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": function ($event) {
                    return _vm.pageSizeChange(
                      $event,
                      "materialSearchForm",
                      "fatchMaterial"
                    )
                  },
                  "current-change": function ($event) {
                    return _vm.pageNumberChange(
                      $event,
                      "materialSearchForm",
                      "fatchMaterial"
                    )
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelDcMultipleDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelDcMultipleDialog = $event
            },
          },
        },
        [
          _c("SelDc", {
            ref: "selectDcMultipleRef",
            attrs: { multipleSelectionFlag: false },
            on: { subCallMethod: _vm.selectDcMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _c("SelSupplier", {
            ref: "supplierSelRef",
            on: { subCallMethod: _vm.selectSupplierMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelPickupPointDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelPickupPointDialog = $event
            },
          },
        },
        [
          _c("SelPickupPoint", {
            ref: "selPickupPointRef",
            on: { subCallMethod: _vm.selectPickupPointMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报价明细",
            visible: _vm.dialogEditVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogEditVisible = $event
            },
            close: _vm.onCancel,
          },
        },
        [
          _c(
            "el-table",
            {
              ref: "tableDataRef",
              attrs: {
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "eightBitCode",
                  label: "8位码",
                  width: "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "eightBitCodeName",
                  label: "8位码名称",
                  width: "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "pickupPoint",
                  label: "提货点",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { "suffix-icon": "el-icon-search" },
                          on: {
                            focus: function ($event) {
                              return _vm.showSelPickupPointDialogFunc(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.pickupPoint,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "pickupPoint", $$v)
                            },
                            expression: "scope.row.pickupPoint",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "dcName",
                  label: "到货仓库（DC）",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-input",
                          {
                            attrs: { "suffix-icon": "el-icon-search" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.showSelDcDialogFunc("1", scope.row)
                              },
                            },
                            model: {
                              value: scope.row.dcName,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "dcName", $$v)
                              },
                              expression: "scope.row.dcName",
                            },
                          },
                          [_vm._v(" ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "transportaionMethod",
                  label: "运输方式",
                  width: "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: scope.row.transportaionMethod,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "transportaionMethod", $$v)
                              },
                              expression: "scope.row.transportaionMethod",
                            },
                          },
                          _vm._l(
                            _vm.transportaionMethodList,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "temperatureI18n",
                  label: "温区",
                  width: "70",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "effectiveBeginDate",
                  label: "产品有效开始日期",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "value-format": "yyyy-MM-dd",
                            type: "date",
                            "picker-options":
                              _vm.searchForm.applyType == 4
                                ? _vm.pickerOptions
                                : "",
                            placeholder: _vm.$t("common.selDate"),
                          },
                          model: {
                            value: scope.row.effectiveBeginDate,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "effectiveBeginDate", $$v)
                            },
                            expression: "scope.row.effectiveBeginDate",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "supplierNames",
                  label: "入围供应商",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.supplierNames
                          ? _c(
                              "el-popover",
                              { attrs: { trigger: "hover", placement: "top" } },
                              [
                                _c("p", [
                                  _vm._v(_vm._s(scope.row.supplierNames)),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "name-wrapper",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          "suffix-icon": "el-icon-search",
                                        },
                                        on: {
                                          οnmοuseοver: function ($event) {
                                            this.title = scope.row.supplierNames
                                          },
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.showSelSupplierFunc(
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.supplierNames,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "supplierNames",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.supplierNames",
                                        },
                                      },
                                      [_vm._v(" ")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _c(
                              "el-input",
                              {
                                attrs: { "suffix-icon": "el-icon-search" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.showSelSupplierFunc(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.supplierNames,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "supplierNames", $$v)
                                  },
                                  expression: "scope.row.supplierNames",
                                },
                              },
                              [_vm._v(" ")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }